import { apiClient } from "../../../client";
import { StandardAxiosConfig, getBaseDataURL, parseDates } from "../../../common";
import { BaseDataModel } from "../../../../../../models";

export class UpdateAPI_Base<T extends BaseDataModel> {
	private router: string;
	protected baseUrl: string;

	constructor(router: string) {
		this.router = router;
		this.baseUrl = `${getBaseDataURL(router)}/update`;
	}

	/** Update multiple records */
	public async many(records: T[], triggerNotesProcessing: boolean = false): Promise<T[]> {
		const url = `${this.baseUrl}?trigger_notes_processing=${triggerNotesProcessing}`;

		const response = await apiClient.post(url, records, StandardAxiosConfig());
		if (response.status !== 200) {
			throw new Error(`Update failed for ${this.router}: ${response.statusText}`);
		}
		const updatedRecords = response.data as T[];
		parseDates<T>(updatedRecords);
		return updatedRecords;
	}

	/** Update a single record */
	public async one(record: T): Promise<T | undefined> {
		const updatedRecords = await this.many([record]);
		return updatedRecords.length > 0 ? updatedRecords[0] : undefined;
	}
}
